import React from 'react';
import { cn } from '../../utils';
import { PROVIDER_CONFIG, ProviderType } from '../../constants/provider';

interface GatewayBadgeProps {
  provider?: string | null;
  className?: string;
}

/**
 * Badge showing transaction gateway (LinkMePay blue, BTCPay orange, 0x violet, GGUS teal).
 * Unknown provider falls back to gray with raw value.
 */
const GatewayBadge: React.FC<GatewayBadgeProps> = ({ provider, className }) => {
  const key = (provider || '').toLowerCase();
  const config = key ? (PROVIDER_CONFIG[key as ProviderType] ?? {
    label: (provider && provider.charAt(0).toUpperCase() + provider.slice(1).replace(/_/g, ' ')) || '—',
    bgClass: 'bg-gray-100',
    textClass: 'text-gray-800',
  }) : null;

  if (!config) {
    return <span className={cn('text-sm text-muted-foreground', className)}>—</span>;
  }

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        config.bgClass,
        config.textClass,
        className
      )}
    >
      {config.label}
    </span>
  );
};

export default GatewayBadge;
